//https://kazupon.github.io/vue-i18n/started.html#javascript
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

const messages = {
  en: {
    language: {
      no_groups:"There are no groups.",
      done:"Done",
      time_to_update:"This app version is too old. Please go to the store and update schoolapp.",
      latest_news:"News",
      latest_calendar:"Calendar",
      latest_albums:"Albums",
      lang_choice:"Choose your language",
      user_get_all_pushnotes:"Receive all pushnotifications",
      user_get_important_pushnotes:"Receive only important pushnotifications",
      page_settings:"Accounts",
      page_menu:"Menu",
      divider_above_groups:"Top level content",
      divider_other:"Other",
      profile_picture:"Avatar",
      add_school:"Add new school",
      provide_url:"School url",
      provide_email:"E-mail address",
      provide_password:"Password",
      provide_name:"Insert name",
      provide_tel:"Insert telephonenumber",
      message:"Message",
      support:"Support",
      suggestions:"Do you have any suggestions for the schoolapp?",
      add_new_school_button:"Add school",
      wrong_school_url:"Wrong url",
      could_not_login:"Unable to login. Verify your credentials",
      user_already_present:"Duplicate User not allowed",
      login_school_button:"Login",
      login_existing_school:"My schools",
      login_success:"Logged in as ",
      other_settings_button:"Pushnotifications",
      current_loggedin:"Currently logged in:",
      school_deleted_success:"School deleted",
      not_loggedin_on_school:"Please login on a school",
      delete_school_sure:"Delete this school?",
      group_news_button:"News",
      group_news_parents:"Parents",
      group_news_group:"Group",
      group_news_validate:"Validate",
      group_news_my_messages:"My messages",
      group_calendar_button:"Calendar",
      group_album_button:"Albums",
      group_email_button:"Emails",
      group_documents_button:"Documents",
      calendar:"Calendar",
      news:"News",
      add_calendar_item:"Add calendaritem",
      add_news_item:"Add newsitem",
      add_photoalbum:"Add photoalbum",
      albums:"Photoalbums",
      confirm:"Send",
      gallery:"Photo's from gallery",
      camera:"Use camera",
      no_json:"No JSON object",
      no_push_plugin:"Phonegap.plugin.push not initialized",
      divider_todo:"Parent-teacher conference",
      divider_belangrijk:"Important",
      divider_news:"News",
      divider_groups:"Groups",
      divider_calendar:"Calendar",
      divider_photoalbum:"Photoalbums",
      divider_newsletters:"Newsletters",
      divider_documents:"Documents",
      divider_callsick:"Absences",
      view_more_news:"More news",
      view_more_calendar:"View calendar",
      view_more_albums:"More photoalbums",
      view_more_newsletters:"More newsletters",
      view_more_documents:"More documents",
      page_news:"News",
      page_emails:"E-mails",
      page_calendar:"Calendar",
      page_albums:"Albums",
      page_newsletters:"Newsletters",
      page_documents:"Documents",
      divider_group_messages:"Group messages",
      page_absence:"Call in sick",
      page_parentspeak:"Parent speak",
      page_contact:"Contact",
      page_support:"Support",
      lees_meer:"Read more...",
      edit:"Edit",
      delete:"Delete",
      date:"Date",
      time_from:"Time from",
      time_to:"Time to",
      title:"Title",
      provide_description:"Description",
      form_incomplete_title:"Please provide a title",
      form_incomplete_description:"Please provide a description",
      form_incomplete_name:"Please provide a name",
      form_incomplete_email:"Please provide an e-mail address",
      form_incomplete_message:"Please provide a message",
      form_incomplete_file:"Missing file",
      place_in_schoolapp:"Place in schoolapp",
      place_on_website:"Place on website",
      place_on_narrow:"Place on schoolscreen",
      send_pushnote:"Send pushnote",
      important_pushnote:"Important pushnote",
      place_in_feed_ouders:"Parents in app",
      place_in_feed_groep:"Pupils in app",
      allow_reactions:"Allow reactions",
      no_news:"There is no news",
      no_newsletters:"There are no newsletters",
      no_calendar:"There is no calendar",
      no_albums:"There are no albums",
      no_emails:"There are no emails",
      add_calendar_item_success:"Added calendaritem",
      add_calendar_item_error:"Error adding calendaritem",
      album_upload_succes:"The album is uploaded",
      album_delete_success:"Album deleted",
      album_delete_sure:"Delete this album?",
      calendar_item_delete_success:"Calendar item deleted",
      calendar_item_delete_sure:"Delete calendar item?",
      news_delete_success:"News item deleted",
      news_delete_sure:"Delete news item?",
      update_calendar_item:"Update calendaritem",
      update_calendar_item_success:"Update calendaritem success",
      update_photoalbum:"Update photoalbum",
      update_newsitem:"Update newsitem",
      loading:"Loading",
      uploading:"Uploading",
      working:"Working",
      add_reaction:"Add reacion",
      delete_reaction_sure:"Delete reaction?",
      send:"Send",
      reactions:"Reactions",
      react:"Comment on this",
      no_reactions:"Be the first to comment",
      news_item_add_success:"Newsitem was added",
      provide_youtube_url:"Youtube url or video id",
      add_optional_images:"Add photo's (optional)",
      news_item_updated:"Nieuwsitem updated",
      album_updated:"Photoalbum updated",
      pushnote_news_item_created:"SchoolsUnited: new newsitem",
      pushnote_album_created:"SchoolsUnited: new album",
      pushnote_chat_created:"SchoolsUnited: new message",
      contact_details:"Contact details",
      support_details:"Schoolapp support",
      approve:"Approve",
      reject:"Park it",
      image_download_success:"Image downloaded",
      image_download_error:"Error downloading image",
      news_reaction_deleted:"Reaction deleted",
      delete_news_item_reaction_sure:"Are you sure you want to delete this reaction?",
      approved:"Approved",
      rejected:"Parked",
      pending:"Pending",
      draft:"Draft",
      no_documents:"There are no document",
      connection_is_secure:"This is a secure connection",
      add_reject_reason:"Motivation when parking",
      heic_images_not_supported:"One or more images are in HEIC format. Please change camera format to jpg. HEIC not supported.",
      message_from_teacher:"Message from teacher",
      groeps_overstijgend:"Homepage",
      no_media_present:"No media present",
      downloading_content:"Downloading content",
      add_documents_item:"Add document",
      choose_pdf:"Choose PDF file",
      uploading_file:"Bestand aan het uploaden",
      upload_file_complete:"File upload completed",
      upload_file_error:"File upload error",
      user_role:"Role",
      full_name:"Name",
      loggedin_on:"Loggedin on",
      user_name:"User name",
      role_parent:"Parent",
      role_teacher:"Teacher",
      role_admin:"Admin",
      role_student:"Pupil",
      pdf_delete_success:"Pdf delete success",
      delete_existing_images:"Delete existing media",
      document_delete_sure:"Delete document?",
      support_sent:"Form sent",
      incorrect_filetype:"Incorrect filetype",
      remove_for_upload:"Remove from upload?",
      update_document:"Update document",
      teacher_talks:"Teacher talks",
      reserve:"Make reservation",
      call_sick:"Absenties",
      unable_talk_reserve:"This timeslot has been reserved. Pick another one",
      choose_talk_slot:"No timeslot selected",
      new_call_sick:"Report new absent",
      add:"Add",
      update_call_sick:"Update absence",
      report_fit_again:"Report fit",
      report_fit_sure:"Unsubscribe this absence?",
      plan_talk_for:"Plan parent teacher talk for:",
      slot_updated:"Talk planned",
      delete_talkslot_sure:"Remove this parent teacher talk?",
      slot_deleted:"Talk deleted",
      view_more_talks:"More parent teacher talks",
      you_are_expected_at:"You are expected at",
      for:"for",
      talk_to_be_planned:"Parent teacher talk to be planned for",
      no_teacher_talks:"There are no parent teacher talks",
      half_day:"half day",
      day:"day",
      days:"days",
      unknown:"unknown",
      make_a_choice:"Make a choice",
      no_absences:"There are no absences",
      name_parent:"Parent name",
      name_child:"Child name",
      description_if_relevant:"Description if relevant",
      description:"Description",
      email:"Email",
      view_more_absences:"View all absences",
      absence_procedure:"Absence procedure",
      absence_procedure_subtitle:"What to do if your child is ill",
      form_incomplete_reason:"Please fill in a reason",
      form_incomplete_duration:"Please fill in the expected duration",
      view_call_sick:"View absence",
      reason:"Reason",
      duration:"Duration",
      choose_file:"Choose file",
      page_pushnotes:"Pushnotifications",
      file_limit_is:"File is too large. Limit is",
      no_pushnotifications:"There are no pushnotifications",
      choose_mobile_file:"Choose Pdf file",
      additional_media:"Additional media",
      maandag:"Monday",
      dinsdag:"Tuesday",
      woensdag:"Wednesday",
      donderdag:"Thursday",
      vrijdag:"Friday",
      zaterdag:"Saturday",
      zondag:"Sunday",
      page_chatpersons:"Chat",
      no_chat_messages:"There are no messages",
      no_chat_persons:"There are no contacts",
      search:"Search",
      no_recent_chats:"No recent chats",
      recent_chats:"Recent chats",
      view_more_chats:"View more chats",
      privacy:"privacy",
      chat_privacy_message:"On August the first  of each year, the complete history of the chat for the past 12 months is automatically deleted. Nobody except you and of course the recipient can see the contents of the chat. Transmissions take place over a secure connection, but the chat is not (currently) stored in encrypted form. Only for support purposes an employee of SchoolsUnited can look into the chat.",
      sunday:"Sunday",
      monday:"Monday",
      tuesday:"Tuesday",
      wednesday:"Wednesday",
      thursday:"Thursday",
      friday:"Friday",
      saturday:"Saturday",
      today:"today",
      yesterday:"yesterday",
      chat:"Chat",
      select_child:"Select child",
      deselect_child:"Deselect child",
      watson_assistant:"Watson Assistant",
      absent:"Reported absent",
      not_absent:"Not reported absent"
    }
  },
  nl: {
    language: {
      no_groups:"Er zijn geen groepen.",
      done:"Afgerond",
      time_to_update:"De app versie is te oud. Update schoolapp nu naar de laatste versie.",
      atest_news:"Nieuws",
      latest_calendar:"Kalender",
      latest_albums:"Albums",
      lang_choice:"Kies uw taal",
      user_get_all_pushnotes:"Alle pushnotificaties ontvangen",
      user_get_important_pushnotes:"Alleen belangrijke pushnotificaties ontvangen",
      page_settings:"Accounts",
      page_menu:"Menu",
      divider_above_groups:"Groepsoverstijgend",
      divider_other:"Overige",
      profile_picture:"Profiel foto",
      add_school:"Een nieuwe school toevoegen",
      provide_url:"Schoolurl",
      provide_email:"E-mail address",
      provide_password:"Password",
      provide_name:"Naam",
      provide_tel:"Telefoon nummer",
      message:"Bericht",
      support:"Ondersteuning",
      suggestions:"Op- of aanmerkingen over de SchoolApp van SchoolsUnited. Geef dit dan hieronder aan. Bedankt!",
      add_new_school_button:"School toevoegen",
      wrong_school_url:"De opgegeven url is niet correct",
      could_not_login:"Inloggen mislukt. Zijn de gegevens juist?",
      user_already_present:"De gebruiker bestaat al",
      login_school_button:"Inloggen",
      login_existing_school:"Mijn scholen",
      login_success:"Je bent ingelogd als ",
      other_settings_button:"Pushnotificaties",
      current_loggedin:"Ingelogde school:",
      school_deleted_success:"School verwijderd",
      not_loggedin_on_school:"Je bent niet ingelogd op een school",
      delete_school_sure:"Deze school verwijderen?",
      group_news_button:"Nieuws",
      group_news_parents:"Ouders",
      group_news_group:"Groep",
      group_news_validate:"Goedkeuren",
      group_news_my_messages:"Mijn berichten",
      group_calendar_button:"Kalender",
      group_album_button:"Albums",
      group_email_button:"Emails",
      group_documents_button:"Documenten",
      calendar:"Kalender",
      news:"Nieuws",
      add_calendar_item:"Toevoegen aan kalender",
      add_news_item:"Nieuwsbericht toevoegen",
      add_photoalbum:"Fotoalbum toevoegen",
      albums:"Fotoalbums",
      confirm:"Versturen",
      gallery:"Foto's uit bibliotheek",
      camera:"Gebruik de camera",
      no_json:"Geen JSON object",
      no_push_plugin:"Phonegap.plugin.push niet geinitialiseerd",
      divider_todo:"Oudergesprekken",
      divider_belangrijk:"Belangrijk",
      divider_news:"Nieuws",
      divider_groups:"Groepen",
      divider_calendar:"Kalender",
      divider_photoalbum:"Fotoalbums",
      divider_newsletters:"Nieuwsbrieven",
      divider_documents:"Documenten",
      divider_callsick:"Absenties",
      view_more_news:"Meer nieuws",
      view_more_calendar:"Naar de kalender",
      view_more_albums:"Meer fotoalbums",
      view_more_newsletters:"Meer nieuwsbrieven",
      view_more_documents:"Meer documenten",
      page_news:"Nieuws",
      page_calendar:"Kalender",
      page_albums:"Albums",
      page_newsletters:"Nieuwsbrieven",
      page_documents:"Documenten",
      page_emails:"Emails",
      divider_group_messages:"Groeps berichten",
      page_absence:"Ziek meldingen",
      page_parentspeak:"Oudergesprekken",
      page_contact:"Contact",
      page_support:"Ondersteuning",
      lees_meer:"Lees meer...",
      edit:"Bewerk",
      delete:"Verwijder",
      date:"Datum",
      time_from:"Start tijd",
      time_to:"Eind tijd",
      title:"Titel",
      provide_description:"Omschrijving",
      form_incomplete_title:"Vul een title in",
      form_incomplete_description:"Vul een omschrijving in",
      form_incomplete_name:"Vul een naam in",
      form_incomplete_email:"Vul een e-mail adres in",
      form_incomplete_message:"Vul een bericht in",
      form_incomplete_file:"Kies een file",
      place_in_schoolapp:"In schoolapp plaatsen",
      place_on_website:"Op website plaatsen",
      place_on_narrow:"Op schoolscherm plaatsen",
      send_pushnote:"Stuur pushnotificatie",
      important_pushnote:"Belangrijke pushnotificatie",
      place_in_feed_ouders:"Ouders in app",
      place_in_feed_groep:"Leerlingen in app",
      allow_reactions:"Reacties toestaan",
      no_news:"Er is geen nieuws",
      no_newsletters:"Er zijn geen nieuwsbrieven",
      no_calendar:"Er is geen kalender",
      no_albums:"Er zijn geen albums",
      no_emails:"Er zijn geen email berichten",
      add_calendar_item_success:"Het kalenderitem is toegevoegd",
      add_calendar_item_error:"Kalenderitem error",
      album_upload_succes:"Het album is geupload",
      album_delete_success:"Album verwijderd",
      album_delete_sure:"Album verwijderen?",
      calendar_item_delete_success:"Kalender item verwijderd",
      calendar_item_delete_sure:"Kalender item verwijderen?",
      news_delete_success:"Nieuws item verwijderd",
      news_delete_sure:"Nieuws item verwijderen?",
      update_calendar_item:"Kalenderitem aanpassen",
      update_calendar_item_success:"kalenderitem aangepast",
      update_photoalbum:"Album aanpassen",
      update_newsitem:"Nieuwsbericht aanpassen",
      loading:"Laden",
      uploading:"Uploaden",
      working:"Bezig",
      add_reaction:"Reactie toevoegen",
      delete_reaction_sure:"Reactie verwijderen?",
      send:"Verzenden",
      reactions:"Reacties",
      react:"Reageren",
      no_reactions:"Reageer als eerste",
      news_item_add_success:"Nieuwsitem is toegevoegd",
      provide_youtube_url:"Youtube url of video id",
      add_optional_images:"Foto's toevoegen (optioneel)",
      news_item_updated:"Nieuwsbericht aangepast",
      album_updated:"Fotoalbum aangepast",
      pushnote_news_item_created:"SchoolsUnited: nieuw nieuwsbericht",
      pushnote_album_created:"SchoolsUnited: nieuw album",
      pushnote_chat_created:"SchoolsUnited: nieuw chatbericht",
      contact_details:"Contactgegevens",
      support_details:"Schoolapp ondersteuning",
      approve:"Goedkeuren",
      reject:"Parkeren",
      image_download_success:"De foto is gedownload",
      image_download_error:"De foto kon niet worden gedownload",
      file_download_success:"Bestand is gedownload.",
      file_download_error:"Bestand kon niet worden gedownload",
      news_reaction_deleted:"Reactie verwijderd",
      delete_news_item_reaction_sure:"Reactie verwijderen?",
      approved:"Goedgekeurd",
      rejected:"Geparkeerd",
      pending:"In de wacht",
      draft:"Schets",
      no_documents:"Er zijn geen documenten",
      connection_is_secure:"Deze verbinding is beveiligd",
      add_reject_reason:"Motivatie in geval van parkeren",
      heic_images_not_supported:"Er zijn afbeeldingen in HEIC formaat gevonden. Dit formaat wordt niet ondersteund. Ga naar camera instellingen om het formaat om te zetten naar JPG.",
      message_from_teacher:"Bericht van de leerkracht",
      groeps_overstijgend:"Groepsoverstijgend",
      no_media_present:"Er is geen media aanwezig",
      downloading_content:"Bezig met downloaden",
      add_documents_item:"Document toevoegen",
      choose_pdf:"PDF file kiezen",
      uploading_file:"Bestand uploaden",
      upload_file_complete:"Bestand upload afgerond",
      upload_file_error:"Bestand upload error",
      user_role:"Rol",
      full_name:"Naam",
      loggedin_on:"Ingelogd op",
      user_name:"Gebruikersnaam",
      role_parent:"Ouder",
      role_teacher:"Leerkracht",
      role_admin:"Beheerder",
      role_student:"Leerling",
      pdf_delete_success:"Bestand is verwijderd",
      delete_existing_images:"Bestaande media verwijderen",
      document_delete_sure:"Document verwijderen?",
      support_sent:"Formulier verstuurd",
      incorrect_filetype:"File type is incorrect",
      remove_for_upload:"Verwijderen voor upload?",
      update_document:"Document aanpassen",
      teacher_talks:"Oudergesprekken",
      reserve:"Reserveren",
      call_sick:"Absenties",
      unable_talk_reserve:"Deze tijd is al gereserveerd. Kies een andere tijd.",
      choose_talk_slot:"Kies een tijd",
      new_call_sick:"Nieuwe absentie melden",
      add:"Toevoegen",
      update_call_sick:"Absentie aanpassen",
      report_fit_again:"Beter melden",
      report_fit_sure:"Deze absentie afmelden?",
      plan_talk_for:"Oudergesprek inplannen voor:",
      slot_updated:"Gesprek ingepland",
      delete_talkslot_sure:"Gesprek verwijderen?",
      slot_deleted:"Gesprek verwijderd",
      view_more_talks:"Meer oudergesprekken",
      you_are_expected_at:"U wordt verwacht om",
      for:"voor",
      talk_to_be_planned:"Oudergesprek inplannen voor",
      no_teacher_talks:"Er zijn geen oudergesprekken",
      half_day:"halve dag",
      day:"dag",
      days:"dagen",
      unknown:"onbekend",
      make_a_choice:"Maak een keuze",
      no_absences:"Er zijn geen absenties",
      name_parent:"Naam ouder",
      name_child:"Naam kind",
      description_if_relevant:"Omschrijving indien relevant",
      description:"Omschrijving",
      email:"Email",
      view_more_absences:"Alle absenties bekijken",
      absence_procedure:"Absentie procedure",
      absence_procedure_subtitle:"Wat te doen als uw kind ziek is",
      form_incomplete_reason:"Vul een reden in",
      form_incomplete_duration:"Vul de verwachte duur in",
      view_call_sick:"Absentie bekijken",
      reason:"Reden",
      duration:"Verwachte duur",
      choose_file:"Bestand kiezen",
      page_pushnotes:"Pushnotificaties",
      file_limit_is:"Het bestand is te groot. De limiet is",
      no_pushnotifications:"Er zijn geen pushnotificaties",
      choose_mobile_file:"Pdf file kiezen",
      additional_media:"Additionele media",
      maandag:"Maandag",
      dinsdag:"Dinsdag",
      woensdag:"Woensdag",
      donderdag:"Donderdag",
      vrijdag:"Vrijdag",
      zaterdag:"Zaterdag",
      zondag:"Zondag",
      page_chatpersons:"Chat",
      no_chat_messages:"Er zijn geen berichten",
      no_chat_persons:"Er zijn geen contacten",
      search:"Zoeken",
      no_recent_chats:"Geen recente chats",
      recent_chats:"Recente chats",
      view_more_chats:"Meer chats bekijken",
      privacy:"privacy",
      chat_privacy_message:"Op 1 augustus van ieder jaar wordt de complete historie van de chat van de afgelopen 12 maanden automatisch gewist. Niemand behalve jijzelf en natuurlijk de ontvanger kan de inhoud van de chat inzien. Er wordt over een beveiligde verbinding heen en weer gezonden, maar de chat wordt (momenteel) nog niet versleuteld opgeslagen. Enkel voor support doeleinden kan een medewerker van SchoolsUnited in de chat kijken.",
      sunday:"Zondag",
      monday:"Maandag",
      tuesday:"Dinsdag",
      wednesday:"Woensdag",
      thursday:"Donderdag",
      friday:"Vrijdag",
      saturday:"Zaterdag",
      today:"vandaag",
      yesterday:"gisteren",
      chat:"Chat",
      select_child:"Selecteer kind",
      deselect_child:"Deselecteer kind",
      watson_assistant:"Watson Assistant",
      absent:"Absent gemeld",
      not_absent:"Niet absent gemeld"
    }
  },
  it: {
    language: {
      no_groups:"Non ci sono gruppi",
      done:"Fatto",
      time_to_update:"Questa versione dell'app è troppo vecchia. Vai al Play Store e aggiorna schoolapp.",
      latest_news:"Notizie",
      latest_calendar:"Calendario",
      latest_albums:"Albums",
      lang_choice:"Scegli la tua lingua",
      user_get_all_pushnotes:"Ricevi tutte le pushnotificazioni",
      user_get_important_pushnotes:"Ricevi solo importanti pushnotificazioni",
      page_settings:"Accounts",
      page_menu:"Menu",
      divider_above_groups:"Contenuto di alto livello",
      divider_other:"Altro",
      profile_picture:"Avatar",
      add_school:"Aggiungi nuova scuola",
      provide_url:"Indirizzo URL della scuola",
      provide_email:"Indirizzo email",
      provide_password:"Password",
      provide_name:"Inserisci il nome",
      provide_tel:"Inserisci il numero di telefono",
      message:"Messaggio",
      support:"Supporto",
      suggestions:"Hai qualche suggerimento per lo schoolapp?",
      add_new_school_button:"Aggiungi scuola",
      wrong_school_url:"Indirizzo errato",
      could_not_login:"Impossibile fare il log in. Verifica le tue credenziali",
      user_already_present:"Utente duplicato non consentito",
      login_school_button:"Login",
      login_existing_school:"Le mie scuole",
      login_success:"Collegato come ",
      other_settings_button:"Pushnotifications",
      current_loggedin:"Attualmente connesso:",
      school_deleted_success:"Scuola cancellata",
      not_loggedin_on_school:"Effettua il login in una scuola",
      delete_school_sure:"Cancella questa scuola?",
      group_news_button:"Notizie",
      group_news_parents:"Genitori",
      group_news_group:"Gruppo",
      group_news_validate:"ijm ",
      group_news_my_messages:"I miei messaggi",
      group_calendar_button:"Calendario",
      group_album_button:"Albums",
      group_email_button:"Emails",
      group_documents_button:"Documenti",
      calendar:"Calendario",
      news:"Notizie",
      add_calendar_item:"Aggiungi una nota nel calendario",
      add_news_item:"Aggiungi notizia",
      add_photoalbum:"Aggiungi album fotografico",
      albums:"Album fotografici",
      confirm:"Inviare",
      gallery:"Foto dalla galleria",
      camera:"Usa la fotocamera",
      no_json:"Nessun oggetto JSON",
      no_push_plugin:"phonegap.plugin.push non inizializzato",
      divider_todo:"Conferenza genitori-insegnanti",
      divider_belangrijk:"Importante",
      divider_news:"Notizie",
      divider_groups:"Gruppi",
      divider_calendar:"Calendario",
      divider_photoalbum:"Album fotografici",
      divider_newsletters:"Newsletters",
      divider_documents:"Documents",
      divider_callsick:"Assenze",
      view_more_news:"Più notizie",
      view_more_calendar:"Visualizza il calendario",
      view_more_albums:"Altri album fotografici",
      view_more_newsletters:"Altre newsletter",
      view_more_documents:"Più documenti",
      page_news:"Notizie",
      page_emails:"E-mails",
      page_calendar:"Calendario",
      page_albums:"Albums",
      page_newsletters:"Newsletters",
      page_documents:"Documents",
      divider_group_messages:"Messaggi di gruppo",
      page_absence:"Chiamare malato",
      page_parentspeak:"Riunione per genitori",
      page_contact:"Contatto",
      page_support:"Supporto",
      lees_meer:"Leggi di più...",
      edit:"Modificare",
      delete:"Elimina",
      date:"Data",
      time_from:"Dalle ore",
      time_to:"Fino alle ore",
      title:"Titolo",
      provide_description:"Descrizione",
      form_incomplete_title:"Si prega di fornire un titolo",
      form_incomplete_description:"Si prega di fornire una descrizione",
      form_incomplete_name:"Si prega di fornire un nome",
      form_incomplete_email:"Si prega di fornire un indirizzo e-mail",
      form_incomplete_message:"Si prega di fornire un messaggio",
      form_incomplete_file:"File mancante",
      place_in_schoolapp:"Mettere a scuola",
      place_on_website:"Posizionare sul sito Web",
      place_on_narrow:"Posiziona sullo schermo della scuola",
      send_pushnote:"Invia pushnote",
      important_pushnote:"Importante Pushnotification",
      place_in_feed_ouders:"Per i propri genitori a schoolapp",
      place_in_feed_groep:"Per gruppo a schoolapp",
      allow_reactions:"Consenti reazioni",
      no_news:"Non ci sono notizie",
      no_newsletters:"Non ci sono newsletter",
      no_calendar:"Non c'è calendario",
      no_albums:"Non ci sono album",
      no_emails:"Non ci sono email",
      add_calendar_item_success:"Calendario aggiunto",
      add_calendar_item_error:"Errore durante l'aggiunta di calendaritem",
      album_upload_succes:"L'album è stato caricato",
      album_delete_success:"Album cancellato",
      album_delete_sure:"Elimina questo album?",
      calendar_item_delete_success:"Calendario eliminato",
      calendar_item_delete_sure:"Elimina l'elemento del calendario?",
      news_delete_success:"Notizia eliminata",
      news_delete_sure:"Elimina la notizia?",
      update_calendar_item:"Aggiorna elemento del calendario",
      update_calendar_item_success:"Aggiornamento del calendario riuscito",
      update_photoalbum:"Aggiorna album fotografico",
      update_newsitem:"Aggiorna notizia",
      loading:"Caricamento in corso",
      uploading:"Caricamento",
      working:"Working",
      add_reaction:"Aggiungi reazione",
      delete_reaction_sure:"Elimina la reazione?",
      send:"Inviare",
      reactions:"Reazioni",
      react:"Lascia un commento",
      no_reactions:"Diventa il primo a commentare",
      news_item_add_success:"La notizia è stata aggiunta",
      provide_youtube_url:"URL di YouTube o ID video",
      add_optional_images:"Aggiungi foto (opzionale)",
      news_item_updated:"Notizia aggiornato",
      album_updated:"Photoalbum aggiornato",
      pushnote_news_item_created:"SchoolsUnited: nuova notizia",
      pushnote_album_created:"SchoolsUnited: nuovo album fotografico",
      pushnote_chat_created:"TODO: SchoolsUnited: new message",
      contact_details:"Dettagli di contatto",
      support_details:"Schoolapp supporto",
      approve:"Approvare",
      reject:"Rifiutare",
      image_download_success:"Immagine scaricata",
      image_download_error:"Errore durante il download dell'immagine",
      news_reaction_deleted:"Reazione eliminata",
      delete_news_item_reaction_sure:"Sei sicuro di voler eliminare questa reazione?",
      approved:"Approvato",
      rejected:"Respinto",
      pending:"In attesa",
      draft:"Bozza",
      no_documents:"Non ci sono documenti",
      connection_is_secure:"Questa è una connessione sicura",
      add_reject_reason:"Motivazione se respinta",
      heic_images_not_supported:"Una o più immagini sono in formato HEIC. Modifica il formato della fotocamera in jpg. HEIC non supportato.",
      message_from_teacher:"Messaggio dell'insegnante",
      groeps_overstijgend:"Homepage",
      no_media_present:"Nessun media presente",
      downloading_content:"Scaricare contenuti",
      add_documents_item:"Aggiungi documento",
      choose_pdf:"Scegli il file PDF",
      uploading_file:"Caricamento file",
      upload_file_complete:"Caricamento del file completato",
      upload_file_error:"Errore di caricamento del file",
      user_role:"Ruolo",
      full_name:"Nome",
      loggedin_on:"Loggato",
      user_name:"Nome utente",
      role_parent:"Gentore",
      role_teacher:"Insegnante",
      role_admin:"Admin",
      role_student:"Allievo",
      pdf_delete_success:"Pdf cancella successo",
      delete_existing_images:"Elimina le immagini esistenti",
      document_delete_sure:"Elimina documento?",
      support_sent:"Modulo inviato",
      incorrect_filetype:"Filetype non corretto",
      remove_for_upload:"Rimuovere dall'upload?",
      update_document:"Aggiorna il documento",
      teacher_talks:"Colloqui con l'insegnante",
      reserve:"Prendere appuntamento",
      call_sick:"Assenze",
      unable_talk_reserve:"Questa fascia oraria è stata riservata. Scegline un altro",
      choose_talk_slot:"Nessuna fascia oraria selezionata",
      new_call_sick:"Segnala una assenza",
      add:"TODO: add",
      update_call_sick:"Aggiornare l'assenza",
      report_fit_again:"Segnalazione in buona salute",
      report_fit_sure:"TODO: Unsubscribe this absence?",
      plan_talk_for:"Pianificare il colloquio genitori-insegnanti per:",
      slot_updated:"Colloquio programmato",
      delete_talkslot_sure:"Eliminare questo colloquio genitore-insegnante?",
      slot_deleted:"Colloquio cancellato",
      view_more_talks:"Altri colloqui con l'insegnante-genitore",
      you_are_expected_at:"Siete attesi al",
      for:"per",
      talk_to_be_planned:"Il colloquio con l'insegnante-genitore programmato per",
      no_teacher_talks:"Non ci sono colloqui tra genitori e insegnanti",
      half_day:"mezza giornata",
      day:"giorno",
      days:"giorni",
      unknown:"unknown",
      make_a_choice:"Fai una scelta",
      no_absences:"Non ci sono assenze",
      name_parent:"Nome del genitore",
      name_child:"Nome del bambino",
      description_if_relevant:"Descrizione se necessario",
      description:"Descrizione",
      email:"Email",
      view_more_absences:"Visualizza tutte le assenze",
      absence_procedure:"Procedura di assenza",
      absence_procedure_subtitle:"Cosa fare se vostro figlio è malato",
      form_incomplete_reason:"Si prega di compilare un motivo",
      form_incomplete_duration:"Si prega di compilare la durata prevista",
      view_call_sick:"Visualizza assenza",
      reason:"Motivo",
      duration:"Tempistica",
      choose_file:"Scegli file",
      page_pushnotes:"Pushnotifications",
      file_limit_is:"Il file e' troppo grande. Massimo:",
      no_pushnotifications:"Non ci sono pushnotifications",
      choose_mobile_file:"Scegli un PDF file",
      additional_media:"Aggiungi media",
      maandag:"Lunedi",
      dinsdag:"Martedi",
      woensdag:"Mercoledi",
      donderdag:"Giovedi",
      vrijdag:"Venerdi",
      zaterdag:"Sabato",
      zondag:"Domenica",
      page_chatpersons:"TODO: Chat",
      no_chat_messages:"TODO: There are no messages",
      no_chat_persons:"TODO: There are no contacts",
      search:"TODO: search",
      no_recent_chats:"TODO: No recent chats",
      recent_chats:"TODO: Recent chats",
      view_more_chats:"TODO: View more chats",
      privacy:"TODO: privacy",
      chat_privacy_message:"Il 1° agosto di ogni anno, la storia completa della chat degli ultimi 12 mesi sarà cancellata automaticamente. Nessuno tranne voi e naturalmente il destinatario può vedere il contenuto della chat. Le trasmissioni avvengono su una connessione sicura, ma la chat non è (attualmente) criptata. Solo per scopi di supporto un dipendente di SchoolsUnited può guardare nella chat.",
      sunday:"TODO: Sunday",
      monday:"TODO: Monday",
      tuesday:"TODO: Tuesday",
      wednesday:"TODO: Wednesday",
      thursday:"TODO: Thursday",
      friday:"TODO: Friday",
      saturday:"TODO: Saturday",
      today:"TODO: today",
      yesterday:"TODO: yesterday",
      chat:"Chat",
      select_child:"TODO: Select child",
      deselect_child:"TODO: Deselect child",
      watson_assistant:"Watson Assistant",
      absent:"TODO: Reported absent",
      not_absent:"TODO: Not reported absent"
    }
  },
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  Locale: 'nl', // Set locale
  messages, // Set locale messages
})

export default i18n;